import { withStyles } from '@material-ui/styles';

import FormTextField from 'retired/FormTextField';
import { white } from 'utils/color-styles';

const FormTextFieldStyle = {
  root: {
    '& fieldset': {
      border: '1px solid rgba(0, 0, 0, 0.1)',
      borderRadius: 16,
    },
    '& label': {
      color: 'rgba(0, 0, 0, 0.35)',
      backgroundColor: white,
      paddingRight: 8,
    },
  },
};

const FormTextFieldRedesign = withStyles(FormTextFieldStyle)(FormTextField);

export default FormTextFieldRedesign;
